export enum ModelElementType {
  NODE = 'NODE',
  LINK = 'LINK',
  SMAP = 'SMAP'
}

export enum ModelScope {
  MAP = 'MAP',
  USER = 'USER',
  GLOBAL = 'GLOBAL'
}

export enum ModelType {
  REGULAR = 'REGULAR',
  DEFAULT_STYLE = 'DEFAULT_STYLE'
}

export interface InclusionOptions {
  includeName: boolean;
  includeDescription: boolean;
  includeProperties: boolean;
  includePropertyValues: boolean;
  includeStyles: boolean;
  eraseUnrelatedProperties: boolean;
}

export interface ElementDefinition {
  originalElement: any; // Partial node/link/map entity
  metadata?: any[];
}

export interface ModelDto {
  id: string;
  name: string;
  description?: string;
  elementType: ModelElementType;
  scope: ModelScope;
  type: ModelType;
  inclusionOptions: InclusionOptions;
  elementDefinition?: ElementDefinition; // Template element data
  ownerId?: string;
  ownerName?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateModelDto {
  name: string;
  description?: string;
  elementType: ModelElementType;
  elementId: string; // ID of the node or link to create model from
  inclusionOptions: InclusionOptions;
  mapId: string; // Required for now, will become optional when USER/GLOBAL scopes are added
}

export interface UpdateModelDto {
  name?: string;
  description?: string;
  inclusionOptions?: InclusionOptions;
  // MAP-1569: when provided, the model's elementDefinition (name, description,
  // properties, property values, styles) is fully re-captured from this live
  // node/link (the canvas' current "selection focus"), regardless of
  // inclusionOptions - mirrors createModel's snapshot behavior.
  elementId?: string;
}

export interface InstantiateModelDto {
  context: InstantiationContext;
}

export interface InstantiationContext {
  parentNodeId?: string; // For creating child nodes
  sourceNodeId?: string; // For creating links with specific source
  position?: { x: number; y: number }; // For positioning new elements
  mapId: string;
}

export interface ApplyModelDto {
  elementIds: string[]; // IDs of elements to apply model to
  mapId: string;
  inclusionOptions: InclusionOptions; // Override model's stored inclusion options
}

export interface ModelPreview {
  elementType: ModelElementType;
  name?: string;
  description?: string;
  color?: string;
  type?: string; // Node type or link type
  properties?: string[]; // List of property names for preview
}

export interface ModelsResponse {
  nodeModels: ModelDto[];
  linkModels: ModelDto[];
}

export interface ApplyModelResponse {
  success: boolean;
  message: string;
  appliedCount: number;
  updatedElements: any[];
}

export interface SetDefaultStyleDto {
  elementType: ModelElementType;
  elementId?: string; // For NODE/LINK
  mapId?: string; // For SMAP
}

export interface DefaultStylesDto {
  nodeDefault?: ModelDto;
  linkDefault?: ModelDto;
  smapDefault?: ModelDto;
}

export interface CreateModelDto {
  name: string;
  description?: string;
  elementType: ModelElementType;
  elementId: string; // ID of the node or link to create model from
  inclusionOptions: InclusionOptions;
  mapId: string; // Required for now, will become optional when USER/GLOBAL scopes are added
}

export interface InstantiateModelDto {
  context: InstantiationContext;
}

export interface InstantiationContext {
  parentNodeId?: string; // For creating child nodes
  sourceNodeId?: string; // For creating links with specific source
  position?: { x: number; y: number }; // For positioning new elements
  mapId: string;
}

export interface ApplyModelDto {
  elementIds: string[]; // IDs of elements to apply model to
  mapId: string;
  inclusionOptions: InclusionOptions; // Override model's stored inclusion options
}

export interface ModelPreview {
  elementType: ModelElementType;
  name?: string;
  description?: string;
  color?: string;
  type?: string; // Node type or link type
  properties?: string[]; // List of property names for preview
}